import React from 'react';
import { Route, Switch } from 'react-router-dom';

import routes from '../../routes.path';

import { BatchSummary } from './BatchSummary';
import Dashboard from './Dashboard/Dashboard';

const Transactions: React.FC = () => (
  <Switch>
    <Route
      exact
      path={
        [
          routes.transactions.base,
          routes.transactions.forwardTrades,
          routes.transactions.payments,
          routes.transactions.transfer,
          routes.transactions.optionTrades,
        ]
      }
    >
      <Dashboard />
    </Route>

    <Route
      exact
      path={routes.transactions.uploadSummary}
      component={BatchSummary}
    />

  </Switch>
);

export default Transactions;
